/**
 * analytics.js
 * Unified event tracking — pushes to GTM dataLayer (routed to GA4 via GTM)
 * and Vercel Analytics simultaneously.
 */

import { track } from '@vercel/analytics'

/**
 * Track a custom event via GTM dataLayer and Vercel Analytics.
 * @param {string} eventName - The event name (snake_case)
 * @param {Object} params    - Optional event parameters
 */
export function trackEvent(eventName, params = {}) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: eventName, ...params })
  track(eventName, params)
}